// Availability and confidence are separate: recorded spend can support a
// provisional ratio, but zero/missing spend never supports a finite ROAS.
export function roasPresentation(spend: number, revenue: number, complete?: boolean, allowProvisional = true) {
  if (!Number.isFinite(spend) || !Number.isFinite(revenue) || spend <= 0) {
    return { value: '—', label: complete === false ? 'Spend missing' : 'No spend', provisional: false, positive: false };
  }
  const ratio = revenue / spend;
  const provisional = complete === false;
  if (provisional && !allowProvisional) return { value: '—', label: 'Spend incomplete', provisional: false, positive: false };
  return {
    value: `${ratio.toFixed(2)}×`,
    label: provisional ? 'Provisional ROAS' : 'ROAS',
    provisional,
    positive: !provisional && ratio >= 1,
  };
}

export function channelSpendComplete(rows: Array<{spendComplete?: boolean}>) {
  return rows.length > 0 && rows.every(row => row.spendComplete !== false);
}
